module.exports = __webpack_public_path__ + "img/yellow1.c510a7e8.svg";